import React from "react"

export function IconHelp(props: React.HTMLAttributes<HTMLDivElement>) {
  //
  return (
    <div {...props}>
      <b>Available icons</b>
      <ul className="list-disc list-inside ml-4">
        <li>
          <a href="https://heroicons.com" target="_blank" rel="noreferrer"
             className="text-indigo-400 hover:text-decoration-underline">Hero Icons (hero-, hero-*-outline, hero-*-mini, hero-*-micro)</a> <sup>new!</sup>
        </li>
        <li>
          <a href="https://lucide.dev/icons/" target="_blank" rel="noreferrer"
             className="text-indigo-400 hover:text-decoration-underline">Lucide (lucide-)</a>
        </li>
        <li>
          <a href="https://fontawesome.com/search?o=r&m=free" target="_blank" rel="noreferrer"
             className="text-indigo-400 hover:text-decoration-underline">Font Awesome (fa-)</a>
        </li>
        <li>
          <a href="https://www.radix-ui.com/icons" target="_blank" rel="noreferrer"
             className="text-indigo-400 hover:text-decoration-underline">Radix Icons (radix-)</a>
        </li>
        <li>
          <a href="https://mui.com/material-ui/material-icons/" target="_blank" rel="noreferrer"
             className="text-indigo-400 hover:text-decoration-underline">Material UI Icons (mui-)</a>
        </li>
      </ul>
      Examples: <code>fa-user</code>,{' '}
      <code>fa-minus-circle</code>,{' '}
      <code>radix-layers</code>,{' '}
      <code>radix-dots-horizontal</code>,{' '}
      <code>mui-add</code>,{' '}
      <code>lucide-badge-info</code>.
    </div>
  );
}